import React from "react";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import LanguageToggle from "../../components/languageToggle";

const OnBoardingLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { i18n, t } = useTranslation();
  const isRTL = i18n.language === 'ar';

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-neo-bg via-neo-bg to-neo-matt/10">
      {/* Main content container */}
      <div className="flex flex-col w-full transition-all duration-300 p-3 sm:p-4 lg:p-6 gap-y-4 sm:gap-y-6">
        
        {/* Enhanced Header */}
        <header 
          className={`
            flex ${isRTL ? 'flex-row-reverse' : 'flex-row'} 
            bg-white/80 backdrop-blur-sm
            justify-between items-center
            p-4 sm:p-5 lg:p-6
            rounded-2xl sm:rounded-3xl
            shadow-sm hover:shadow-md
            transition-all duration-300
            border border-gray-100
          `}
          role="banner"
        >
          {/* Logo Section */}
          <div className={`flex items-center ${isRTL ? 'flex-row-reverse' : 'flex-row'} gap-2 sm:gap-3`}>
            <Typography className="text-neo-primary font-poppins-700 text-xl sm:text-2xl lg:text-3xl">
              NeoPaas
            </Typography>
            {import.meta.env.VITE_ENV_LABEL && (
              <Typography className="text-neo-primary/70 font-poppins-300 text-xs mt-1">
                {import.meta.env.VITE_ENV_LABEL}
              </Typography>
            )}
          </div>

          {/* Language Toggle Section */}
          <div className="flex items-center">
            <LanguageToggle icon />
          </div>
        </header>

        {/* Content Area with enhanced styling */}
        <main 
          className="
            flex flex-1 
            bg-white/60 backdrop-blur-sm
            rounded-2xl sm:rounded-3xl
            shadow-sm
            border border-gray-100
            p-4 sm:p-6 lg:p-8
            transition-all duration-300
            overflow-y-auto
          "
          role="main"
        >
          <div className="w-full max-w-7xl mx-auto">
            {children}
          </div>
        </main>

        {/* Footer - Optional subtle branding */}
        <footer 
          className={`
            text-center text-xs sm:text-sm 
            text-gray-400 
            py-2 sm:py-3
            font-poppins-300
          `}
          role="contentinfo"
        >
          <Typography className="text-gray-400 font-poppins-300">
            {t("footer.copyright", { year: new Date().getFullYear() })}
          </Typography>
        </footer>
      </div>
    </div>
  );
};

export default OnBoardingLayout;
